import { render, staticRenderFns } from "./BaseYN.vue?vue&type=template&id=0c72cb65&scoped=true"
import script from "./BaseYN.vue?vue&type=script&lang=js"
export * from "./BaseYN.vue?vue&type=script&lang=js"
import style0 from "./BaseYN.vue?vue&type=style&index=0&id=0c72cb65&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c72cb65",
  null
  
)

export default component.exports